import { TextSelection } from '../composables/processTextSelection'
import { getWordIndex } from '../utils'

export function isSelectionEmpty(selection: TextSelection | null): boolean {
  return (
    !selection ||
    (!!selection.rangeBoundaries &&
      selection.rangeBoundaries.width === 0 &&
      selection.rangeBoundaries.height === 0)
  )
}

export function getSelectionIndices(range: Range | null): number[] {
  if (!range || !range.startContainer || !range.endContainer) {
    return []
  }

  const firstSelectionWord = range.startContainer as HTMLElement
  const lastSelectionWord = range.endContainer as HTMLElement

  if (
    firstSelectionWord &&
    !!firstSelectionWord.dataset &&
    !!firstSelectionWord.dataset.index &&
    lastSelectionWord &&
    !!lastSelectionWord.dataset &&
    !!lastSelectionWord.dataset.index
  ) {
    const idx1 = getWordIndex(firstSelectionWord)
    const idx2 = getWordIndex(lastSelectionWord)

    if (idx1 === -1 || idx2 === -1) {
      return []
    }

    return [idx1, idx2]
  }

  return []
}

export function getSelectionTimeScope(range: Range | null): number[] {
  if (!range || !range.startContainer || !range.endContainer) {
    return []
  }

  const firstSelectionWord = range.startContainer as HTMLElement
  const lastSelectionWord = range.endContainer as HTMLElement

  if (
    firstSelectionWord &&
    !!firstSelectionWord.dataset &&
    !!firstSelectionWord.dataset.timecodeStart &&
    lastSelectionWord &&
    !!lastSelectionWord.dataset &&
    !!lastSelectionWord.dataset.timecodeEnd
  ) {
    const selectionStartTimecode: number = parseInt(
      firstSelectionWord.dataset.timecodeStart
    )
    const selectionEndTimecode: number = parseInt(
      lastSelectionWord.dataset.timecodeEnd
    )

    return [selectionStartTimecode, selectionEndTimecode]
  }

  return []
}
